import { TransferKbn } from "../../../assets/data/Constants";
import TkButton from "../../../components/atoms/TkButton";

function infoBodyList(res: any, handelEntry: any) {
  const infoBodyList: any[] = [];
  res?.forEach((item: any) => {
    const data = [
      {
        children: (item.staffNo ?? "") + ":" + (item.staffNameKanji ?? ""),
        forSort: (item.staffNo ?? "") + ":" + (item.staffNameKanji ?? ""),
        align: "center",
      },
      {
        children:
          (item.bFacilityNo ?? "") +
          ":" +
          (item.bFacilityName ?? "契約対象外施設"),
        forSort:
          (item.bFacilityNo ?? "") +
          ":" +
          (item.bFacilityName ?? "契約対象外施設"),
        align: "center",
      },
      {
        children:
          (item.aFacilityNo ?? "") +
          ":" +
          (item.aFacilityName ?? "契約対象外施設"),
        forSort:
          (item.aFacilityNo ?? "") +
          ":" +
          (item.aFacilityName ?? "契約対象外施設"),
        align: "center",
      },
      {
        children:
          item.transferDateType === TransferKbn["転出"]
            ? item.transferDate
            : item.returnDate,
        forSort:
          item.transferDateType === TransferKbn["転出"]
            ? item.transferDate
            : item.returnDate,
        align: "center",
      },
      {
        children: item.processStatus,
        forSort: item.processStatus,
        align: "center",
      },
      {
        children: <TkButton onClick={() => handelEntry(item)}>確認</TkButton>,
        align: "center",
      },
    ];
    infoBodyList.push(data);
  });
  return infoBodyList;
}

export { infoBodyList };
